var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2399,
    height: 739,
    viewBox: "0 0 2399 739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117411",
    "data-name": "Group 117411",
    transform: "translate(-5210 4320)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2015",
    "data-name": 2015,
    transform: "translate(5334 -4260)",
    fill: "#183240",
    fontSize: 56,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2015")), /*#__PURE__*/React.createElement("text", {
    id: "_2016",
    "data-name": 2016,
    transform: "translate(5633 -3875)",
    fill: "#183240",
    fontSize: 56,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60
  }, "2016")), /*#__PURE__*/React.createElement("text", {
    id: "_2017",
    "data-name": 2017,
    transform: "translate(5970 -4305)",
    fill: "#183240",
    fontSize: 56,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60
  }, "2017")), /*#__PURE__*/React.createElement("text", {
    id: "_2018",
    "data-name": 2018,
    transform: "translate(6272 -3875)",
    fill: "#183240",
    fontSize: 56,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60
  }, "2018")), /*#__PURE__*/React.createElement("text", {
    id: "_2019",
    "data-name": 2019,
    transform: "translate(6590 -4305)",
    fill: "#183240",
    fontSize: 56,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60
  }, "2019")), /*#__PURE__*/React.createElement("text", {
    id: "Launch_of_ZIIEI",
    "data-name": "Launch of ZIIEI",
    transform: "translate(5334 -4192)",
    fill: "#183240",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Launch of ZIIEI")), /*#__PURE__*/React.createElement("text", {
    id: "Launch_of_Innovative_Pathshaala",
    "data-name": "Launch of Innovative Pathshaala",
    transform: "translate(5970 -4217)",
    fill: "#183240",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "Launch of Innovative "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }, "Pathshaala")), /*#__PURE__*/React.createElement("text", {
    id: "_18_Innovations_Handbooks_Launched",
    "data-name": "18 Innovations Handbooks Launched",
    transform: "translate(6590 -4217)",
    fill: "#183240",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "18 Innovations "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }, "Handbooks Launched")), /*#__PURE__*/React.createElement("text", {
    id: "First_Innovations_Handbook_Navachar_Pustika_Launched",
    "data-name": "First Innovations Handbook (Navachar Pustika) Launched",
    transform: "translate(5633 -3782)",
    fill: "#183240",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "First Innovations "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }, "Handbook (Navachar "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 112
  }, "Pustika) Launched")), /*#__PURE__*/React.createElement("text", {
    id: "Expanded_Reach_from_1_State_to_21_States",
    "data-name": "Expanded Reach from 1 State to 21 States",
    transform: "translate(6272 -3782)",
    fill: "#183240",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "Expanded Reach from "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }, "1 State to 21 States")), /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    x2: 1872,
    transform: "translate(5292.5 -3997.5)",
    fill: "none",
    stroke: "#3769e1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    y1: 213.73,
    transform: "translate(5292.5 -4287.73)",
    fill: "none",
    stroke: "#183240",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(5284 -4301.73)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_235",
    "data-name": "Ellipse 235",
    transform: "translate(5210 -4074)",
    fill: "#fff",
    stroke: "#191919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_25-2",
    "data-name": "Line 25",
    y2: 213.73,
    transform: "translate(5599.5 -3921)",
    fill: "none",
    stroke: "#183240",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50-2",
    "data-name": "Ellipse 50",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(5590 -3712.274)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    transform: "translate(5523 -4074)",
    fill: "#fff",
    stroke: "#191919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_25-3",
    "data-name": "Line 25",
    y1: 213.73,
    transform: "translate(5919.5 -4287.73)",
    fill: "none",
    stroke: "#183240",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50-3",
    "data-name": "Ellipse 50",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(5911 -4301.73)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    transform: "translate(5837 -4074)",
    fill: "#fff",
    stroke: "#191919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_25-4",
    "data-name": "Line 25",
    y2: 213.73,
    transform: "translate(6226.5 -3921)",
    fill: "none",
    stroke: "#183240",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50-4",
    "data-name": "Ellipse 50",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(6217 -3712.274)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    transform: "translate(6150 -4074)",
    fill: "#fff",
    stroke: "#191919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_25-5",
    "data-name": "Line 25",
    y1: 213.73,
    transform: "translate(6545.5 -4287.73)",
    fill: "none",
    stroke: "#183240",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50-5",
    "data-name": "Ellipse 50",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(6537 -4301.73)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_240",
    "data-name": "Ellipse 240",
    transform: "translate(6463 -4074)",
    fill: "#fff",
    stroke: "#191919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_25-6",
    "data-name": "Line 25",
    y2: 213.73,
    transform: "translate(6853.5 -3921)",
    fill: "none",
    stroke: "#183240",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50-6",
    "data-name": "Ellipse 50",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(6844 -3712.274)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_243",
    "data-name": "Ellipse 243",
    transform: "translate(6777 -4074)",
    fill: "#fff",
    stroke: "#191919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2021",
    "data-name": 2021,
    transform: "translate(7228 -4305)",
    fill: "#183240",
    fontSize: 56,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60
  }, "2021")), /*#__PURE__*/React.createElement("text", {
    id: "Launch_of_Establishment_of_Role-Model_Schools_in_300_Districts",
    "data-name": "Launch of Establishment of Role-Model Schools in 300 Districts",
    transform: "translate(7228 -4217)",
    fill: "#183240",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "Launch of Establishment of "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }, "Role-Model Schools in 300 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 112
  }, "Districts")), /*#__PURE__*/React.createElement("line", {
    id: "Line_25-7",
    "data-name": "Line 25",
    y1: 213.73,
    transform: "translate(7172.5 -4287.73)",
    fill: "none",
    stroke: "#183240",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50-7",
    "data-name": "Ellipse 50",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(7164 -4301.73)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_240-2",
    "data-name": "Ellipse 240",
    transform: "translate(7090 -4074)",
    fill: "#fff",
    stroke: "#191919",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 76,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 76,
    r: 75.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_2020",
    "data-name": 2020,
    transform: "translate(6887 -3875)",
    fill: "#183240",
    fontSize: 56,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 60
  }, "2020")), /*#__PURE__*/React.createElement("text", {
    id: "_35_Innovations_Handbooks_Navachar_Pustika_Launched_Around_1_000_Teachers_Education_Officers_Felicitated",
    "data-name": "35 Innovations Handbooks (Navachar Pustika) Launched ; Around 1,000 Teachers & Education Officers Felicitated",
    transform: "translate(6888 -3782)",
    fill: "#183240",
    fontSize: 28,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 30
  }, "35 Innovations Handbooks "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 71
  }, "(Navachar Pustika) "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 112
  }, "Launched ; Around 1,000 "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 153
  }, "Teachers &amp; Education "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 194
  }, "Officers Felicitated")), /*#__PURE__*/React.createElement("g", {
    id: "Group_12820",
    "data-name": "Group 12820",
    transform: "translate(6680.31 -4066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23386",
    "data-name": "Path 23386",
    d: "M250.883,174.439a3.617,3.617,0,0,0,3.611-3.615v-22.38a3.613,3.613,0,0,0-7.177-.6,5.947,5.947,0,0,0-4.9,5.21,7.044,7.044,0,0,0,0,13.154,5.948,5.948,0,0,0,4.9,5.21,3.621,3.621,0,0,0,3.566,3.018Zm-2.562-5.158a3.713,3.713,0,0,1-3.71-3.7l-1.112-.049,1.121-.068a1.114,1.114,0,0,0-.842-1.153,4.817,4.817,0,0,1,0-9.349,1.112,1.112,0,0,0,.842-1.153c0-.006-.009-.1-.009-.109a3.709,3.709,0,0,1,3.681-3.71,1.113,1.113,0,0,0,1.229-1.273,1.726,1.726,0,0,1-.028-.27,1.388,1.388,0,1,1,2.776,0v22.38a1.388,1.388,0,1,1-2.776,0,1.7,1.7,0,0,1,.028-.269,1.1,1.1,0,0,0-.285-.941,1.084,1.084,0,0,0-.787-.34,1.14,1.14,0,0,0-.128.007Z",
    transform: "translate(-83.439 -98.259)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23387",
    "data-name": "Path 23387",
    d: "M361.282,174.442a3.621,3.621,0,0,0,3.566-3.018,5.947,5.947,0,0,0,4.9-5.21,7.044,7.044,0,0,0,0-13.154,5.948,5.948,0,0,0-4.9-5.21,3.613,3.613,0,0,0-7.177.6v22.38A3.617,3.617,0,0,0,361.282,174.442ZM359.9,148.448a1.388,1.388,0,1,1,2.776,0,1.682,1.682,0,0,1-.029.269,1.1,1.1,0,0,0,.285.942,1.08,1.08,0,0,0,.915.332,3.717,3.717,0,0,1,3.708,3.737c0,.01-.006.081-.007.091a1.113,1.113,0,0,0,.843,1.145,4.817,4.817,0,0,1,0,9.349,1.115,1.115,0,0,0-.843,1.145c0,.01.009.107.01.117a3.708,3.708,0,0,1-3.68,3.71,1.113,1.113,0,0,0-1.231,1.274,1.715,1.715,0,0,1,.028.27,1.388,1.388,0,1,1-2.776,0Z",
    transform: "translate(-184.175 -98.262)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23388",
    "data-name": "Path 23388",
    d: "M230.1,159.086a7.365,7.365,0,0,0,6.415-7.292v-7.817a8.927,8.927,0,0,0,2.9-6.589,6.265,6.265,0,0,1,.63-2.736,6.6,6.6,0,0,1,1.781-2.228,23.19,23.19,0,1,0-29.01.069,6.206,6.206,0,0,1,2.332,4.9,8.931,8.931,0,0,0,2.634,6.355c.084.084.177.158.264.238V151.8a7.366,7.366,0,0,0,6.415,7.292,2.922,2.922,0,0,0,5.639,0Zm-.944-2.6H225.4a4.632,4.632,0,0,1-2.285-.62l10.383-2.331a4.687,4.687,0,0,1-4.346,2.951Zm-8.441-7.232,13.13-2.942v1.747L220.712,151Zm0-1.824v-2.3h10.252Zm.115,5.374,13.015-2.921v1.75L221.506,154.4a4.685,4.685,0,0,1-.679-1.6Zm-6.352-22.4a20.521,20.521,0,0,1,11.449-36.516,20.516,20.516,0,0,1,14.22,36.458,9.243,9.243,0,0,0-2.5,3.13,8.963,8.963,0,0,0-.9,3.912,6.268,6.268,0,0,1-2.578,5.072H220.382a6.207,6.207,0,0,1-.717-.6,6.277,6.277,0,0,1-1.852-4.467,8.861,8.861,0,0,0-3.339-6.984Z",
    transform: "translate(-55.002 -53.132)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23389",
    "data-name": "Path 23389",
    d: "M139.936,231.47a1.246,1.246,0,0,0,0,2.492h4.721a1.246,1.246,0,0,0,0-2.492Z",
    transform: "translate(0 -171.129)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23390",
    "data-name": "Path 23390",
    d: "M517.176,231.47a1.246,1.246,0,1,0,0,2.492H521.9a1.246,1.246,0,1,0,0-2.492Z",
    transform: "translate(-317.279 -171.129)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23391",
    "data-name": "Path 23391",
    d: "M202.878,93.424a1.246,1.246,0,0,0,.881-2.127l-3.338-3.338a1.246,1.246,0,0,0-1.761,1.761L202,93.059a1.235,1.235,0,0,0,.88.365Z",
    transform: "translate(-50.131 -50.122)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23392",
    "data-name": "Path 23392",
    d: "M467.158,354.709a1.246,1.246,0,0,0-1.761,1.761l3.338,3.338a1.246,1.246,0,0,0,1.762-1.761Z",
    transform: "translate(-274.47 -274.472)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23393",
    "data-name": "Path 23393",
    d: "M198.649,359.816a1.246,1.246,0,0,0,1.762,0l3.338-3.338a1.246,1.246,0,1,0-1.761-1.761l-3.338,3.338a1.244,1.244,0,0,0,0,1.761Z",
    transform: "translate(-50.122 -274.479)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23394",
    "data-name": "Path 23394",
    d: "M470.506,87.959a1.245,1.245,0,0,0-1.761,0L465.407,91.3a1.246,1.246,0,1,0,1.762,1.761l3.338-3.338a1.245,1.245,0,0,0,0-1.761Z",
    transform: "translate(-274.479 -50.122)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23395",
    "data-name": "Path 23395",
    d: "M342.16,29.246v4.721a1.246,1.246,0,1,0,2.492,0V29.246a1.246,1.246,0,1,0-2.492,0Z",
    transform: "translate(-171.129)",
    fill: "#f9b123"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_23396",
    "data-name": "Path 23396",
    d: "M71.732-.02A1.754,1.754,0,0,0,70,1.988V15.8a1.753,1.753,0,1,0,3.506,0v-.026h0V5.986L84.536,17.019a1.753,1.753,0,1,0,2.477-2.481L75.98,3.505H85.8A1.753,1.753,0,1,0,85.8,0H71.961a1.569,1.569,0,0,0-.232-.017Zm45.567,0A1.565,1.565,0,0,0,117.1,0H103.281a1.753,1.753,0,1,0,0,3.506H113.1L102.065,14.536a1.754,1.754,0,0,0,2.481,2.481L115.58,5.984V15.8a1.753,1.753,0,1,0,3.506,0v-.026h0V1.965a1.8,1.8,0,0,0,.015-.232A1.752,1.752,0,0,0,117.348-.02H117.3ZM71.724,31.532A1.754,1.754,0,0,0,70,33.285v.026h0V47.344c0,.051,0,.1.008.15v-.008a.248.248,0,0,1,0,.029V47.51c0,.052.012.1.02.141v-.011c0,.028.008.044.011.06V47.69a1.77,1.77,0,0,0,.167.46l0-.009a.406.406,0,0,0,.026.048l0-.009c.026.046.048.083.072.12l0-.006a.422.422,0,0,0,.026.04l0-.006a1.772,1.772,0,0,0,.338.364l0,0s.009.009.015.014h0a1.743,1.743,0,0,0,1.042.375h0a.318.318,0,0,0,.038,0H85.8a1.753,1.753,0,1,0,0-3.506H75.981L87.013,34.545a1.753,1.753,0,0,0-1.223-3.009h-.049a1.75,1.75,0,0,0-1.205.528L73.5,43.1V33.283a1.753,1.753,0,0,0-1.753-1.753h-.026Zm45.585,0a1.754,1.754,0,0,0-1.728,1.753v.026h0V43.1L104.547,32.07a1.746,1.746,0,0,0-1.257-.531h0a1.752,1.752,0,0,0-1.22,3.009L113.1,45.581h-9.816a1.753,1.753,0,1,0,0,3.506h14.05a1.734,1.734,0,0,0,.531-.083l-.012,0,.014-.006-.009,0a1.528,1.528,0,0,0,.173-.063l-.011,0,.02-.009-.009,0c.06-.026.109-.051.157-.077l-.009,0,.011-.008,0,0a1.848,1.848,0,0,0,.24-.158l0,0c.026-.02.046-.037.067-.055h0a1.413,1.413,0,0,0,.109-.1l0,0a1.64,1.64,0,0,0,.207-.262l0-.008c0,.009,0,.008,0,.008l0-.009a1.6,1.6,0,0,0,.081-.14l0-.009c0,.009,0,.008,0,.008l0-.009a1.634,1.634,0,0,0,.121-.311l0-.012c0,.009,0,.008,0,0l0-.012a1.688,1.688,0,0,0,.06-.418h0a.321.321,0,0,0,0-.038V33.286a1.752,1.752,0,0,0-1.753-1.753h-.024Z",
    transform: "translate(6131.02 -4021.98)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23397",
    "data-name": "Path 23397",
    d: "M144.808,76.906h-3.322V74.641a1.107,1.107,0,0,0-.471-.912A23.037,23.037,0,0,0,124,70.088a39.668,39.668,0,0,0-15.643,6.286A23.293,23.293,0,0,0,97.843,65.839a19.146,19.146,0,0,0-16.014-.562,1.121,1.121,0,0,0-.684,1.026v4.378a21.433,21.433,0,0,0-6.354,3.055,1.117,1.117,0,0,0-.471.912v2.265H71.005a1.119,1.119,0,0,0-1.117,1.117v43.347a1.119,1.119,0,0,0,1.117,1.117H144.8a1.119,1.119,0,0,0,1.117-1.117V78.023a1.108,1.108,0,0,0-1.11-1.117Zm-5.548-1.672v40.793c-8.551-4.591-19.154-3.436-30.236,3.314V78.608c10.968-7.441,22.186-8.695,30.236-3.375ZM83.38,67.055c9.873-3.686,19.717,2.8,23.41,11.2v39.9a31.548,31.548,0,0,0-8.262-7.677,19.4,19.4,0,0,0-10.1-2.645,30.015,30.015,0,0,0-5.047.456Zm-6.826,8.179a19.144,19.144,0,0,1,4.6-2.219v36.627a1.126,1.126,0,0,0,.41.866,1.115,1.115,0,0,0,.935.228c10.55-2.2,16.113,1.467,20.712,6.612-9.767-4.933-19.025-5.412-26.649-1.315v-40.8ZM72.123,79.14h2.2v38.848a1.117,1.117,0,0,0,1.725.935c7.646-4.978,17.444-4.484,27.871,1.33h-31.8Zm71.569,41.113h-31.8c10.428-5.815,20.226-6.316,27.871-1.33a1.117,1.117,0,0,0,1.725-.935V79.14h2.2Z",
    transform: "translate(6431.112 -4090.787)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12821",
    "data-name": "Group 12821",
    transform: "translate(5752.032 -4091.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23381",
    "data-name": "Path 23381",
    d: "M149.782,390.2a1.485,1.485,0,0,0,2.15,0l11.824-11.824a1.52,1.52,0,0,0-2.15-2.15L149.782,387.97a1.738,1.738,0,0,0,0,2.226Z",
    transform: "translate(-15.886 -269.084)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23382",
    "data-name": "Path 23382",
    d: "M158.291,347.321l5.912-5.912a1.52,1.52,0,0,0-2.15-2.15l-5.912,5.912a1.484,1.484,0,0,0,0,2.15,1.485,1.485,0,0,0,2.15,0Z",
    transform: "translate(-21.324 -237.189)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23383",
    "data-name": "Path 23383",
    d: "M171.518,66.9a44.9,44.9,0,0,0-20.347,15.433,19.522,19.522,0,0,0-12.515,3.839c-4.377,3.379-6.91,8.83-7.678,16.047a1.62,1.62,0,0,0,.845,1.535,2.246,2.246,0,0,0,.691.154,1.516,1.516,0,0,0,1.075-.461l8.523-8.523a1.52,1.52,0,1,0-2.15-2.15l-5.068,5.068a17.165,17.165,0,0,1,5.6-9.214,15.621,15.621,0,0,1,8.523-3.148,60.154,60.154,0,0,0-5.452,11.133,1.427,1.427,0,0,0,.384,1.613l7.6,7.6a1.52,1.52,0,1,0,2.15-2.15l-6.91-6.91a53.252,53.252,0,0,1,6.219-11.748c.077-.077.154-.154.154-.23A40.475,40.475,0,0,1,170.98,70.437l2.688,2.688a1.485,1.485,0,0,0,2.15,0,1.484,1.484,0,0,0,0-2.15l-1.689-1.689a45.979,45.979,0,0,1,13.821-2.226,43.3,43.3,0,0,1-2.226,13.821l-7.064-7.064a1.52,1.52,0,0,0-2.15,2.15l8.062,8.062A40.854,40.854,0,0,1,170.29,101.84l-.077.077a52.907,52.907,0,0,1-11.9,6.3l-1.689-1.689a1.52,1.52,0,0,0-2.15,2.15l2.38,2.38a1.516,1.516,0,0,0,1.075.461,1.31,1.31,0,0,0,.538-.077,60.08,60.08,0,0,0,11.133-5.452,15.621,15.621,0,0,1-3.148,8.523,16.558,16.558,0,0,1-9.214,5.6l3.148-3.148a1.52,1.52,0,0,0-2.15-2.15l-6.6,6.6a1.514,1.514,0,0,0-.307,1.766,1.45,1.45,0,0,0,1.382.845h.154c7.218-.768,12.669-3.3,16.047-7.678a19.055,19.055,0,0,0,3.839-12.515A44.834,44.834,0,0,0,188.1,83.49a43.6,43.6,0,0,0,2.841-18.12,1.486,1.486,0,0,0-1.382-1.382,44.045,44.045,0,0,0-18.044,2.917Z",
    transform: "translate(0)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23384",
    "data-name": "Path 23384",
    d: "M229.5,420.682a1.485,1.485,0,0,0,2.15,0l5.912-5.912a1.52,1.52,0,1,0-2.15-2.15l-5.912,5.912a1.485,1.485,0,0,0,0,2.15Z",
    transform: "translate(-84.628 -300.491)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23385",
    "data-name": "Path 23385",
    d: "M360.561,185.2a7.694,7.694,0,0,0,0-10.979,7.785,7.785,0,0,0-11.057,0,7.694,7.694,0,0,0,0,10.979,7.785,7.785,0,0,0,11.057,0Zm-8.83-8.83a4.59,4.59,0,0,1,3.3-1.382,4.464,4.464,0,0,1,3.3,1.382,4.726,4.726,0,0,1,0,6.68,4.59,4.59,0,0,1-3.3,1.382,4.464,4.464,0,0,1-3.3-1.382A4.727,4.727,0,0,1,351.731,176.374Z",
    transform: "translate(-186.586 -93.192)",
    fill: "#f9b123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12822",
    "data-name": "Group 12822",
    transform: "translate(5125.032 -4091.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23381-2",
    "data-name": "Path 23381",
    d: "M149.782,390.2a1.485,1.485,0,0,0,2.15,0l11.824-11.824a1.52,1.52,0,0,0-2.15-2.15L149.782,387.97a1.738,1.738,0,0,0,0,2.226Z",
    transform: "translate(-15.886 -269.084)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23382-2",
    "data-name": "Path 23382",
    d: "M158.291,347.321l5.912-5.912a1.52,1.52,0,0,0-2.15-2.15l-5.912,5.912a1.484,1.484,0,0,0,0,2.15,1.485,1.485,0,0,0,2.15,0Z",
    transform: "translate(-21.324 -237.189)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23383-2",
    "data-name": "Path 23383",
    d: "M171.518,66.9a44.9,44.9,0,0,0-20.347,15.433,19.522,19.522,0,0,0-12.515,3.839c-4.377,3.379-6.91,8.83-7.678,16.047a1.62,1.62,0,0,0,.845,1.535,2.246,2.246,0,0,0,.691.154,1.516,1.516,0,0,0,1.075-.461l8.523-8.523a1.52,1.52,0,1,0-2.15-2.15l-5.068,5.068a17.165,17.165,0,0,1,5.6-9.214,15.621,15.621,0,0,1,8.523-3.148,60.154,60.154,0,0,0-5.452,11.133,1.427,1.427,0,0,0,.384,1.613l7.6,7.6a1.52,1.52,0,1,0,2.15-2.15l-6.91-6.91a53.252,53.252,0,0,1,6.219-11.748c.077-.077.154-.154.154-.23A40.475,40.475,0,0,1,170.98,70.437l2.688,2.688a1.485,1.485,0,0,0,2.15,0,1.484,1.484,0,0,0,0-2.15l-1.689-1.689a45.979,45.979,0,0,1,13.821-2.226,43.3,43.3,0,0,1-2.226,13.821l-7.064-7.064a1.52,1.52,0,0,0-2.15,2.15l8.062,8.062A40.854,40.854,0,0,1,170.29,101.84l-.077.077a52.907,52.907,0,0,1-11.9,6.3l-1.689-1.689a1.52,1.52,0,0,0-2.15,2.15l2.38,2.38a1.516,1.516,0,0,0,1.075.461,1.31,1.31,0,0,0,.538-.077,60.08,60.08,0,0,0,11.133-5.452,15.621,15.621,0,0,1-3.148,8.523,16.558,16.558,0,0,1-9.214,5.6l3.148-3.148a1.52,1.52,0,0,0-2.15-2.15l-6.6,6.6a1.514,1.514,0,0,0-.307,1.766,1.45,1.45,0,0,0,1.382.845h.154c7.218-.768,12.669-3.3,16.047-7.678a19.055,19.055,0,0,0,3.839-12.515A44.834,44.834,0,0,0,188.1,83.49a43.6,43.6,0,0,0,2.841-18.12,1.486,1.486,0,0,0-1.382-1.382,44.045,44.045,0,0,0-18.044,2.917Z",
    transform: "translate(0)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23384-2",
    "data-name": "Path 23384",
    d: "M229.5,420.682a1.485,1.485,0,0,0,2.15,0l5.912-5.912a1.52,1.52,0,1,0-2.15-2.15l-5.912,5.912a1.485,1.485,0,0,0,0,2.15Z",
    transform: "translate(-84.628 -300.491)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23385-2",
    "data-name": "Path 23385",
    d: "M360.561,185.2a7.694,7.694,0,0,0,0-10.979,7.785,7.785,0,0,0-11.057,0,7.694,7.694,0,0,0,0,10.979,7.785,7.785,0,0,0,11.057,0Zm-8.83-8.83a4.59,4.59,0,0,1,3.3-1.382,4.464,4.464,0,0,1,3.3,1.382,4.726,4.726,0,0,1,0,6.68,4.59,4.59,0,0,1-3.3,1.382,4.464,4.464,0,0,1-3.3-1.382A4.727,4.727,0,0,1,351.731,176.374Z",
    transform: "translate(-186.586 -93.192)",
    fill: "#f9b123"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_23398",
    "data-name": "Path 23398",
    d: "M144.808,76.906h-3.322V74.641a1.107,1.107,0,0,0-.471-.912A23.037,23.037,0,0,0,124,70.088a39.668,39.668,0,0,0-15.643,6.286A23.293,23.293,0,0,0,97.843,65.839a19.146,19.146,0,0,0-16.014-.562,1.121,1.121,0,0,0-.684,1.026v4.378a21.433,21.433,0,0,0-6.354,3.055,1.117,1.117,0,0,0-.471.912v2.265H71.005a1.119,1.119,0,0,0-1.117,1.117v43.347a1.119,1.119,0,0,0,1.117,1.117H144.8a1.119,1.119,0,0,0,1.117-1.117V78.023a1.108,1.108,0,0,0-1.11-1.117Zm-5.548-1.672v40.793c-8.551-4.591-19.154-3.436-30.236,3.314V78.608c10.968-7.441,22.186-8.695,30.236-3.375ZM83.38,67.055c9.873-3.686,19.717,2.8,23.41,11.2v39.9a31.548,31.548,0,0,0-8.262-7.677,19.4,19.4,0,0,0-10.1-2.645,30.015,30.015,0,0,0-5.047.456Zm-6.826,8.179a19.144,19.144,0,0,1,4.6-2.219v36.627a1.126,1.126,0,0,0,.41.866,1.115,1.115,0,0,0,.935.228c10.55-2.2,16.113,1.467,20.712,6.612-9.767-4.933-19.025-5.412-26.649-1.315v-40.8ZM72.123,79.14h2.2v38.848a1.117,1.117,0,0,0,1.725.935c7.646-4.978,17.444-4.484,27.871,1.33h-31.8Zm71.569,41.113h-31.8c10.428-5.815,20.226-6.316,27.871-1.33a1.117,1.117,0,0,0,1.725-.935V79.14h2.2Z",
    transform: "translate(5491.112 -4090.787)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12823",
    "data-name": "Group 12823",
    transform: "translate(7005.998 -4088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23399",
    "data-name": "Path 23399",
    d: "M127.4,123.211h64.41a1.4,1.4,0,0,0,1.4-1.4V88.206c0-.014-.014-.028-.014-.056a1.605,1.605,0,0,0-.084-.434.917.917,0,0,1-.028-.1.084.084,0,0,1-.014-.056l-5.6-11.2a1.434,1.434,0,0,0-1.261-.755H165.362l-4.355-4.747V67.2h9.8a1.4,1.4,0,0,0,1.4-1.4V57.4a1.4,1.4,0,0,0-1.4-1.4h-11.2a1.4,1.4,0,0,0-1.4,1.4V70.856L153.852,75.6H133a1.385,1.385,0,0,0-1.247.77l-5.6,11.2a.084.084,0,0,0-.014.056.961.961,0,0,0-.028.1,1.137,1.137,0,0,0-.084.434c-.014.013-.028.027-.028.042v33.606a1.4,1.4,0,0,0,1.4,1.4Zm1.4-33.606h14v30.8h-14Zm26.6,30.8v-15.4h8.4v15.4Zm11.2,0v-16.8a1.4,1.4,0,0,0-1.4-1.4h-11.2a1.4,1.4,0,0,0-1.4,1.4v16.8h-7V88.752l14-15.277,14,15.277V120.41Zm23.8,0h-14v-30.8h14ZM185.343,78.4l4.2,8.4H175.625l-7.7-8.4Zm-15.934-14h-8.4V58.8h8.4Zm-35.538,14H151.29l-7.7,8.4H129.67Z",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23400",
    "data-name": "Path 23400",
    d: "M482.068,307.075h5.6a1.4,1.4,0,0,0,1.4-1.4v-5.6a1.4,1.4,0,0,0-1.4-1.4h-5.6a1.4,1.4,0,0,0-1.4,1.4v5.6a1.4,1.4,0,0,0,1.4,1.4Zm1.4-5.6h2.8v2.8h-2.8Z",
    transform: "translate(-301.457 -206.267)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23401",
    "data-name": "Path 23401",
    d: "M482.068,409.735h5.6a1.4,1.4,0,0,0,1.4-1.4v-5.6a1.4,1.4,0,0,0-1.4-1.4h-5.6a1.4,1.4,0,0,0-1.4,1.4v5.6a1.4,1.4,0,0,0,1.4,1.4Zm1.4-5.6h2.8v2.8h-2.8Z",
    transform: "translate(-301.457 -293.525)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23402",
    "data-name": "Path 23402",
    d: "M170.337,298.67h-5.6a1.4,1.4,0,0,0-1.4,1.4v5.6a1.4,1.4,0,0,0,1.4,1.4h5.6a1.4,1.4,0,0,0,1.4-1.4v-5.6A1.4,1.4,0,0,0,170.337,298.67Zm-1.4,5.6h-2.8v-2.8h2.8Z",
    transform: "translate(-31.733 -206.263)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23403",
    "data-name": "Path 23403",
    d: "M170.337,401.33h-5.6a1.4,1.4,0,0,0-1.4,1.4v5.6a1.4,1.4,0,0,0,1.4,1.4h5.6a1.4,1.4,0,0,0,1.4-1.4v-5.6A1.4,1.4,0,0,0,170.337,401.33Zm-1.4,5.6h-2.8v-2.8h2.8Z",
    transform: "translate(-31.733 -293.522)",
    fill: "#f9b123"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23404",
    "data-name": "Path 23404",
    d: "M346.91,223.071h-3.445v-7a1.4,1.4,0,0,0-2.8,0v8.4a1.4,1.4,0,0,0,1.4,1.4h4.845a1.4,1.4,0,0,0,0-2.8Z",
    transform: "translate(-182.458 -134.866)",
    fill: "#f9b123"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.5ed1ed3e3d7b9adf33abd8859bf16e3e.svg";
export { ForwardRef as ReactComponent };